import { createApiConstants } from '@saucelabs/sl-util-redux';

const NAMESPACE = 'web-ui-tunnels';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const INITIALIZE = createApiNamespacedConstants('INITIALIZE');
export const GET_SAUCE_CONNECT_DOWNLOAD_LINKS = createApiNamespacedConstants('GET_SAUCE_CONNECT_DOWNLOAD_LINKS');
